import * as yup from 'yup';
import { validateCpfCnpj } from '../../../shared/utils/functions';

export const schemaProfessional = yup.object().shape({
  name: yup.string().required('Nome obrigatório'),
  cpf: yup
    .string()
    .required('CPF obrigatório')
    .test('test-invalid-cpf', 'cpf/cnpj inválido', (cpf) =>
      validateCpfCnpj(cpf),
    ),
  terminology_id: yup.string().required('Termologia Obrigatória'),
  terminology_code: yup.string().required('Código de Registro Obrigatório'),
});

export const schemaProfessionalSignature = yup.object().shape({
  signature: yup.string().required('Assinatura obrigat[oria'),
  signature_password: yup.string().required('Senha obrigatória'),
  confirmPassword: yup
    .string()
    .required('Confirmação de senha obrigatória')
    .oneOf(
      [yup.ref('signature_password')],
      'Senha não coincide com senha de confirmação.',
    ),
});
